import React, { ReactNode } from "react"
import {
  Dialog as RADialog,
  DialogProps as RADialogProps,
  Heading as RAHeading,
  Modal as RAModal,
  ModalOverlay as RAModalOverlay,
  ModalOverlayProps as RAModalOverlayProps,
} from "react-aria-components"
import "./Modal.scss"
import classNames from "classnames"

/* -------------------------------------------------------------------------------------------------
 * ModalHeader
 * -----------------------------------------------------------------------------------------------*/

export type ModalHeaderProps = {
  children?: ReactNode
}

const ModalHeader = ({ children }: ModalHeaderProps) => {
  return (
    <div className="modal__header">
      <RAHeading className="modal__title" slot="title">
        {children}
      </RAHeading>
    </div>
  )
}

/* -------------------------------------------------------------------------------------------------
 * ModalBody
 * -----------------------------------------------------------------------------------------------*/

export type ModalBodyProps = {
  children?: ReactNode
  className?: string
}

const ModalBody = ({ children, className }: ModalBodyProps) => {
  const classes = classNames(className, "modal__body")
  return <div className={classes}>{children}</div>
}

/* -------------------------------------------------------------------------------------------------
 * ModalFooter
 * -----------------------------------------------------------------------------------------------*/

export type ModalFooterProps = {
  children?: ReactNode
  className?: string
}

const ModalFooter = ({ children, className }: ModalFooterProps) => {
  return <div className={`modal__footer ${className ?? "modal__defaultButtons"}`}>{children}</div>
}
/* -------------------------------------------------------------------------------------------------
 * ModalRoot
 * -----------------------------------------------------------------------------------------------*/

export type ModalRootProps = {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
} & Omit<RAModalOverlayProps, "children"> &
  Pick<RADialogProps, "children">

const ModalRoot = React.forwardRef<HTMLDivElement, ModalRootProps>(({ children, isOpen, onOpenChange }, ref) => {
  return (
    <div className="modal">
      <RAModalOverlay className="modal__overlay" isOpen={isOpen} ref={ref} onOpenChange={onOpenChange}>
        <RAModal className="modal__content nhsuk-width-container">
          <RADialog className="modal__dialog">{children}</RADialog>
        </RAModal>
      </RAModalOverlay>
    </div>
  )
})

ModalRoot.displayName = "Modal"

const Modal = { Root: ModalRoot, Header: ModalHeader, Body: ModalBody, Footer: ModalFooter }

export { Modal }
